/**
 * Created by cahyo wibowo on 1/13/19
 */

import moment from "moment";
import Constant from "../config/Constant";
import { DateUtil } from "./DateUtil";

export const currentDate = new Date();

export const month = currentDate.getMonth() + 1;

export const year = currentDate.getFullYear();

export const statusVirtualAccounts: Array<string> = [
  "ALL",
  "ACTIVE",
  "DONE",
  "EXPIRED"
];

export const statusProseses: Array<string> = [
  "SUDAH",
  "BELUM"
];

export const actives = [
  { label: "AKTIF", value: true },
  { label: "TIDAK", value: false }
];

export const typePembayarans: Array<string> = ["BEBAS", "BULANAN"];

export const statusSantries: Array<string> = [
  "AKTIF",
  "ALUMNI",
  "BOYONG",
  "KHODAM",
  "NON_AKTIF"
];

export const bendaharaTypes: Array<string> = [
  "YAYASAN",
  "MADRASAH",
  "WILAYAH",
  "KOST_MAKAN"
];

/**
 * Menghasilkan daftar Tahun Ajaran untuk Pondok.
 * Transisi tahun ajaran baru menggunakan Kalender Hijriah (mulai 1 Ramadhan).
 * Digunakan sebagai default di SelectTahunAjaran.
 */
export const tahunAjarans = ((): Array<any> => {
  const startThAjaran: number = 2018;
  const isNewYear = DateUtil.isNewAcademicYearGregorian(5); // Pakai seperti sekolah, kalo sudah bulan 5, masuk baru
  let array: Array<number> = new Array((year - startThAjaran) + (isNewYear ? 1 : 0));

  return array.fill(null).map((item, index) => {
    return `${startThAjaran + index}/${startThAjaran + index + 1}`;
  }).sort((a: any, b: any) => {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    }

    return 0;
  });
})();

/**
 * Menghasilkan daftar Tahun Ajaran default (sinkron dengan logic Pondok).
 * Berbasis Hijriah (Ramadhan).
 */
export const defaultTahunAjarans = ((): Array<any> => {
  const startThAjaran: number = 2018;
  const isNewYear = DateUtil.isNewAcademicYear();
  let array: Array<number> = new Array((year - startThAjaran) + (isNewYear ? 1 : 0));

  return array.fill(null).map((item, index) => {
    return `${startThAjaran + index}/${startThAjaran + index + 1}`;
  }).sort((a: any, b: any) => {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    }

    return 0;
  });
})();

/**
 * Menghasilkan daftar Tahun Ajaran untuk PSB.
 * Selalu menyertakan 1 tahun ke depan (prospektif) untuk pendaftaran santri baru.
 */
export const tahunAjaranPsb = ((): Array<any> => {
  const startThAjaran: number = 2018;
  // PSB always includes the prospective year (CurrentYear/CurrentYear+1)
  let array: Array<number> = new Array((year - startThAjaran) + 1);

  return array.fill(null).map((item, index) => {
    return `${startThAjaran + index}/${startThAjaran + index + 1}`;
  }).sort((a: any, b: any) => {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    }

    return 0;
  });
})();

/**
 * Menghasilkan daftar Tahun Ajaran untuk Sekolah.
 * Transisi tahun ajaran baru menggunakan Kalender Masehi (mulai Bulan 4 / April).
 */
export const tahunAjaranSekolah = ((): Array<any> => {
  const startThAjaran: number = 2018;
  const isNewYear = DateUtil.isNewAcademicYearGregorian(4);
  let array: Array<number> = new Array((year - startThAjaran) + (isNewYear ? 1 : 0));

  return array.fill(null).map((item, index) => {
    return `${startThAjaran + index}/${startThAjaran + index + 1}`;
  }).sort((a: any, b: any) => {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    }

    return 0;
  });
})();

/**
 * Default number for search
 */
export const getNumber = () => {
  const year = new Date().getFullYear();
  return `${year}00001`;
};

/**
 * Menghasilkan daftar Tahun Masehi (ALL, 2026, 2025, ... 2018).
 * Ter-generate otomatis mengikuti tahun berjalan.
 */
export const tahuns = ((): Array<any> => {
  const startYear = 2018;
  const list = ["ALL"];
  for (let y = year; y >= startYear; y--) {
    list.push(String(y));
  }
  return list;
})();

export const tingkats = [
  "ALL",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12"
];

export const kelases = [
  "ALL",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "Gizi",
  "Farmasi",
  "Ekonomi Syariah"
];

// Digunakan untuk select tahun ketika membuat pembayaran
export const tahunbulans = ((): Array<any> => {
  const startTh: number = 2018;
  const nextYear: number = year + 1;

  const tahunList = new Array((year - startTh) + 1).fill(null).map((item, index: number) => {
    return year - index;
  });

  return [nextYear, ...tahunList];
})();

export const pendidikans: Array<any> = Object.keys(Constant.PENDIDIKAN).map((item: any) => {
  return { name: item, value: item };
});

export const pendidikanFormals: Array<any> = Object.keys(Constant.PENDIDIKAN_FORMAL).map((item: any) => {
  return { name: item, value: item };
});

export const pendidikanNonFormals: Array<any> = Object.keys(Constant.PENDIDIKAN_NON_FORMAL).map((item: any) => {
  return { name: item, value: item };
});

export const wilayahs = [
  { label: "SEMUA", value: "ALL" },
  { label: "AL-GHAZHIER", value: "GHAZHIER" },
  { label: "AL-JADIED PUTRA", value: "JADIED_PA" },
  { label: "AL-JADIED PUTRA 2", value: "JADIED_PA_2" },
  { label: "AL-JADIED PUTRA 3", value: "JADIED_PA_3" },
  { label: "AL-JADIED PUTRI", value: "JADIED_PI" },
  { label: "AL-NASHIR AL-MANSHUR", value: "AL_NASHIR" },
  { label: "AS-SYIFA", value: "AS_SYIFA" },
  { label: "DAR EL SHOFA", value: "EL_SHOFA" },
  { label: "MADINATUS SHOLAWAT", value: "MADINATUS" },
  { label: "AZ-ZAHRA", value: "AZ_ZAHRA" },
  { label: "MISYKAT AL NURAIN PUTRA", value: "MISYKAT_PA" },
  { label: "MISYKAT AL NURAIN PUTRI", value: "MISYKAT_PI" },
  { label: "MADRASAH", value: "MADRASAH" },
  { label: "YAYASAN", value: "YAYASAN" },
  { label: "MA KHAS Kempek", value: "MA" },
  { label: "SMK KHAS Kempek", value: "SMK" },
  { label: "SMP KHAS Kempek", value: "SMP" },
  { label: "MTS KHAS Kempek", value: "MTS" },
  { label: "STIES KHAS Kempek", value: "STIES" },
  { label: "STIKES KHAS Kempek", value: "STIKES" }
];

export const wilayahPutras = [
  { label: "SEMUA", value: "ALL" },
  { label: "AL-GHAZHIER", value: "GHAZHIER" },
  { label: "AL-JADIED PUTRA", value: "JADIED_PA" },
  { label: "AL-JADIED PUTRA 2", value: "JADIED_PA_2" },
  { label: "AL-JADIED PUTRA 3", value: "JADIED_PA_3" },
  { label: "MISYKAT AL NURAIN PUTRA", value: "MISYKAT_PA" }
];

export const wilayahPutris = [
  { label: "SEMUA", value: "ALL" },
  { label: "AL-JADIED PUTRI", value: "JADIED_PI" },
  { label: "AL-NASHIR AL-MANSHUR", value: "AL_NASHIR" },
  { label: "AS-SYIFA", value: "AS_SYIFA" },
  { label: "DAR EL SHOFA", value: "EL_SHOFA" },
  { label: "MADINATUS SHOLAWAT", value: "MADINATUS" },
  { label: "AZ-ZAHRA", value: "AZ_ZAHRA" },
  { label: "MISYKAT AL NURAIN PUTRI", value: "MISYKAT_PI" }
];

export const asramas = [
  { label: "SEMUA", value: "ALL" },
  { label: "AL - ASYARI", value: "01" },
  { label: "AL - MATURIDI", value: "02" },
  { label: "AL - MUSLIM", value: "03" },
  { label: "AL - BUKHORI", value: "04" },
  { label: "IMAM IBNU MALIK", value: "05" },
  { label: "DARUSHOFA", value: "06" },
  { label: "AS - SYAFI'I", value: "07" },
  { label: "AL - HAMBALI", value: "08" },
  { label: "AL - MALIKI", value: "09" },
  { label: "AL HANAFI", value: "10" },
  { label: "AL GHOZALI", value: "11" },
  { label: "AL JAELANI", value: "12" },
  { label: "HUBBUL WATHON 1", value: "13" },
  { label: "HUBBUL WATHON 2", value: "14" },
  { label: "HUBBUL WATHON 3", value: "15" },
  { label: "AL MAIMOEN 1", value: "16" },
  { label: "AL MAIMOEN 2", value: "17" },
  { label: "SAYYIDAH ZAENAB ATAS", value: "18" },
  { label: "SAYYIDAH ZAENAB BAWAH", value: "19" },
  { label: "ROBIAH AL ADAWIYAH", value: "20" },
  { label: "TSUAIBAH AL ASLAMIYAH", value: "21" },
  { label: "KHODIJAH AL KUBRO", value: "22" },
  { label: "FATIMAH AZ ZAHRO", value: "23" },
  { label: "NYAI AFIFAH HARUN", value: "24" },
  { label: "AZZAHRA 1", value: "25" },
  { label: "AZZAHRA 2", value: "26" },
  { label: "AZZAHRA 3", value: "27" },
  { label: "AZZAHRA 4", value: "28" },
  { label: "AZZAHRA 5", value: "29" },
  { label: "DEWI AMINAH", value: "30" },
  { label: "DEWI FATMAH", value: "31" },
  { label: "DEWI ZAINAH", value: "32" },
  { label: "RABATH", value: "33" },
  { label: "CASABLANCA", value: "34" },
  { label: "OUJDA", value: "35" },
  { label: "NYAI UMI LAILA", value: "36" },
  { label: "NYAI MU'MINAH", value: "37" },
  { label: "ROBIAH NYAI HANAH", value: "38" },
  { label: "MISYKAT AL NURAIN PUTRI", value: "39" },
  { label: "MISYKAT AL NURAIN PUTRA", value: "40" },
  { label: "AL-ZAHRA 6", value: "41" },
  { label: "SAYYIDAH AISYAH", value: "42" },
  { label: "MAHASISWA", value: "43" }
];

export const asramaPutras = [
  { label: "SEMUA", value: "ALL" },
  { label: "AL - ASYARI", value: "01" },
  { label: "AL - MATURIDI", value: "02" },
  { label: "AL - MUSLIM", value: "03" },
  { label: "AL - BUKHORI", value: "04" },
  { label: "IMAM IBNU MALIK", value: "05" },
  { label: "DARUSHOFA", value: "06" },
  { label: "AS - SYAFI'I", value: "07" },
  { label: "AL - HAMBALI", value: "08" },
  { label: "AL - MALIKI", value: "09" },
  { label: "AL HANAFI", value: "10" },
  { label: "AL GHOZALI", value: "11" },
  { label: "AL JAELANI", value: "12" },
  { label: "HUBBUL WATHON 1", value: "13" },
  { label: "HUBBUL WATHON 2", value: "14" },
  { label: "HUBBUL WATHON 3", value: "15" },
  { label: "AL MAIMOEN 1", value: "16" },
  { label: "AL MAIMOEN 2", value: "17" },
  { label: "MAHASISWA", value: "43" }
];

export const asramaPutries = [
  { label: "SEMUA", value: "ALL" },
  { label: "SAYYIDAH ZAENAB ATAS", value: "18" },
  { label: "SAYYIDAH ZAENAB BAWAH", value: "19" },
  { label: "ROBIAH AL ADAWIYAH", value: "20" },
  { label: "TSUAIBAH AL ASLAMIYAH", value: "21" },
  { label: "KHODIJAH AL KUBRO", value: "22" },
  { label: "FATIMAH AZ ZAHRO", value: "23" },
  { label: "NYAI AFIFAH HARUN", value: "24" },
  { label: "AZZAHRA 1", value: "25" },
  { label: "AZZAHRA 2", value: "26" },
  { label: "AZZAHRA 3", value: "27" },
  { label: "AZZAHRA 4", value: "28" },
  { label: "AZZAHRA 5", value: "29" },
  { label: "DEWI AMINAH", value: "30" },
  { label: "DEWI FATMAH", value: "31" },
  { label: "DEWI ZAINAH", value: "32" },
  { label: "RABATH", value: "33" },
  { label: "CASABLANCA", value: "34" },
  { label: "OUJDA", value: "35" },
  { label: "NYAI UMI LAILA", value: "36" },
  { label: "NYAI MU'MINAH", value: "37" },
  { label: "ROBIAH NYAI HANAH", value: "38" },
  { label: "MISYKAT AL NURAIN PUTRI", value: "39" },
  { label: "MISYKAT AL NURAIN PUTRA", value: "40" },
  { label: "AL-ZAHRA 6", value: "41" },
  { label: "SAYYIDAH AISYAH", value: "42" },
  { label: "MAHASISWA", value: "43" }
];

export const sekolahSantries = [
  { label: "LULUS", value: "ALUMNI" },
  { label: "MTs KHAS Kempek", value: "MTS" },
  { label: "SMP KHAS Kempek", value: "SMP" },
  { label: "MA KHAS Kempek", value: "MA" },
  { label: "SMK KHAS Kempek", value: "SMK" },
  { label: "STIKES KHAS Kempek", value: "STIKES" },
  { label: "STIES KHAS Kempek", value: "STIES" },
  { label: "TIDAK", value: "TIDAK" }
];

export const bankAccounts = [
  { label: "SEMUA", value: "ALL" },
  { label: "BRI", value: "BRI" },
  { label: "BSI", value: "BSI" }
];

export const penerimaDana = [
  { label: "YAYASAN KHAS KEMPEK", value: "YSN_KHAS" },
  { label: "AL-GHAZHIER", value: "GHAZHIER" },
  { label: "AL-JADIED PUTRA", value: "JADIED_PA" },
  { label: "AL-JADIED PUTRA 2", value: "JADIED_PA_2" },
  { label: "AL-JADIED PUTRA 3", value: "JADIED_PA_3" },
  { label: "MISYKAT AL NURAIN PUTRA", value: "MISYKAT_PA" },
  { label: "MISYKAT AL NURAIN PUTRI", value: "MISYKAT_PI" },
  { label: "AL-JADIED PUTRI", value: "JADIED_PI" },
  { label: "AL-NASHIR AL-MANSHUR", value: "AL_NASHIR" },
  { label: "AS-SYIFA", value: "AS_SYIFA" },
  { label: "DAR EL SHOFA", value: "EL_SHOFA" },
  { label: "MADINATUS SHOLAWAT", value: "MADINATUS" },
  { label: "AZ-ZAHRA", value: "AZ_ZAHRA" },
  { label: "MADRASAH", value: "MADRASAH" },
  { label: "YAYASAN", value: "YAYASAN" },
  { label: "MA KHAS Kempek", value: "MA" },
  { label: "SMK KHAS Kempek", value: "SMK" },
  { label: "SMP KHAS Kempek", value: "SMP" },
  { label: "MTS KHAS Kempek", value: "MTS" },
  { label: "STIES KHAS Kempek", value: "STIES" },
  { label: "STIKES KHAS Kempek", value: "STIKES" }
];

export const transaksiTypes = [
  { label: "Transaksi Cash", value: "CASH" },
  { label: "Transaksi Virtual Account", value: "VA" }
];

export const ukurans = [
  { label: "Default", value: "NO" },
  { label: "Sudah", value: "SUDAH" },
  { label: "Belum", value: "BELUM" },
  { label: "S", value: "S" },
  { label: "M", value: "M" },
  { label: "L", value: "L" },
  { label: "XL", value: "XL" },
  { label: "XXL", value: "XXL" },
  { label: "XXXL", value: "XXXL" },
  { label: "XXXXL", value: "XXXXL" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
  { label: "25", value: "25" },
  { label: "26", value: "26" },
  { label: "27", value: "27" },
  { label: "28", value: "28" },
  { label: "29", value: "29" },
  { label: "30", value: "30" },
  { label: "31", value: "31" },
  { label: "32", value: "32" },
  { label: "33", value: "33" },
  { label: "34", value: "34" },
  { label: "35", value: "35" },
  { label: "36", value: "36" },
  { label: "37", value: "37" },
  { label: "38", value: "38" },
  { label: "39", value: "39" },
  { label: "40", value: "40" },
  { label: "41", value: "41" },
  { label: "42", value: "42" },
  { label: "43", value: "43" },
  { label: "44", value: "44" },
  { label: "45", value: "45" }
];


export const jenisKelamins = [
  { label: "SEMUA", value: "ALL" },
  { label: "LAKI-LAKI", value: "L" },
  { label: "PEREMPUAN", value: "P" }
];

export const jenisTransfer = [
  { label: "Transfer Manual", value: "MANUAL" },
  { label: "Auto Transfer", value: "AUTO" }
];

export const registrasies = [
  { label: "SEMUA", value: "ALL" },
  { label: "SUDAH", value: "SUDAH" },
  { label: "BELUM", value: "BELUM" }
];

export const statusBayars = [
  { label: "SEMUA", value: "ALL" },
  { label: "SUDAH", value: "SUDAH" },
  { label: "BELUM", value: "BELUM" }
];

export const sudahBelums = [
  { label: "SUDAH", value: "SUDAH" },
  { label: "BELUM", value: "BELUM" }
];

export const lulusans = [
  { label: "SEMUA", value: "ALL" },
  { label: "Non KHAS Kempek", value: "NON_KHAS" },
  { label: "MTS KHAS Kempek", value: "LULUSAN_MTS_KHAS" },
  { label: "SMP KHAS Kempek", value: "LULUSAN_SMP_KHAS" },
  { label: "MA KHAS Kempek", value: "LULUSAN_MA_KHAS" },
  { label: "SMK KHAS Kempek", value: "LULUSAN_SMK_KHAS" }
];

export const kamars = [
  { label: "SEMUA", value: "ALL" },
  { label: "Kamar 01", value: "01" },
  { label: "Kamar 02", value: "02" },
  { label: "Kamar 03", value: "03" },
  { label: "Kamar 04", value: "04" },
  { label: "Kamar 05", value: "05" },
  { label: "Kamar 06", value: "06" },
  { label: "Kamar 07", value: "07" },
  { label: "Kamar 08", value: "08" },
  { label: "Kamar 09", value: "09" },
  { label: "Kamar 10", value: "10" }
];

export const roles = [
  { label: "SUPER ADMIN", value: "ADMIN" },
  { label: "TELLER BANK", value: "TELLER" },
  { label: "ADMIN MTS", value: "MTS" },
  { label: "ADMIN SMP", value: "SMP" },
  { label: "ADMIN MA", value: "MA" },
  { label: "ADMIN SMK", value: "SMK" },
  { label: "ADMIN STIKES", value: "STIKES" },
  { label: "ADMIN STIES", value: "STIES" },
  { label: "ADMIN PSB KEUANGAN", value: "PSB_KEUANGAN" },
  { label: "ADMIN PSB PERSYARATAN", value: "PSB_PERSYARATAN" },
  { label: "ADMIN PSB SERAGAM", value: "PSB_SERAGAM" },
  { label: "ADMIN AL-JADIED PUTRA", value: "JADIED_PA" },
  { label: "ADMIN AL-JADIED PUTRA 2", value: "JADIED_PA_2" },
  { label: "ADMIN AL-JADIED PUTRA 3", value: "JADIED_PA_3" },
  { label: "ADMIN AL-JADIED PUTRI", value: "JADIED_PI" },
  { label: "ADMIN AL-NASHIR AL-MANSHUR", value: "AL_NASHIR" },
  { label: "ADMIN AS-SYIFA", value: "AS_SYIFA" },
  { label: "ADMIN DAR EL SHOFA", value: "EL_SHOFA" },
  { label: "ADMIN MADINATUS SHOLAWAT", value: "MADINATUS" },
  { label: "ADMIN AZ ZAHRA", value: "AZ_ZAHRA" },
  { label: "ADMIN AL-GHAZHIER", value: "GHAZHIER" },
  { label: "ADMIN MISYKAT AL NURAIN PUTRA", value: "MISYKAT_PA" },
  { label: "ADMIN MISYKAT AL NURAIN PUTRI", value: "MISYKAT_PI" },
  { label: "PEMILIK KANTIN", value: "KANTIN" },
  { label: "PETUGAS KANTIN", value: "PETUGAS_KANTIN" },
  { label: "KOPERASI KHAS KEMPEK", value: "KOPERASI" },
  { label: "PETUGAS PRESENSI", value: "PETUGAS_PRESENSI" },
  { label: "GURU PENGAJIAN", value: "GURU_PENGAJIAN" },
  { label: "MASYAYIKH", value: "MASYAYIKH" },
  { label: "BENDAHARA PUSAT", value: "BENDAHARA_PUSAT" },
  { label: "BENDAHARA", value: "BENDAHARA" },
  { label: "MTM MADRASAH PUTRI", value: "MTM_MADRASAH_PUTRI" },
  { label: "MTM MADRASAH PUTRA", value: "MTM_MADRASAH_PUTRA" }
];

export const TUK_FULL_ACCESS_ROLES = ["ADMIN", "BENDAHARA_PUSAT", "MASYAYIKH"];

export const pengajians = [
  { label: "SEMUA", value: "ALL" },
  { label: "Al Awamil", value: "AWAM" },
  { label: "Al Ajurumiyyah", value: "AJURU" },
  { label: "Al Amrithi", value: "AMRI" },
  { label: "Al Mutammimah", value: "MUTTA" },
  { label: "Alfiyah Ula", value: "ULA" },
  { label: "Alfiyah Tsani", value: "TSANI" },
  { label: "1 Wustho", value: "WUSTHO_1" },
  { label: "2 Wustho", value: "WUSTHO_2" },
  { label: "3 Wustho", value: "WUSTHO_3" },
  { label: "1 Ulya", value: "ULYA_1" },
  { label: "2 Ulya", value: "ULYA_2" },
  { label: "3 Ulya", value: "ULYA_3" },
  { label: "Purna Alfiyah L", value: "PURNA_PA" },
  { label: "Purna Alfiyah P", value: "PURNA_PI" },
  { label: "Mutakhorijin L", value: "MUTAKHOR_PA" },
  { label: "Mutakhorijin P", value: "MUTAKHOR_PI" },
  { label: "Al Ajurumiyyah Misykat", value: "10_AJURU" },
  { label: "Al Amrithi Misykat", value: "11_AMR" },
  { label: "Alfiyah Misykat", value: "12_ALFI" }
];

export const pengajianPutries = [
  { label: "SEMUA", value: "ALL" },
  { label: "1 Wustho", value: "WUSTHO_1" },
  { label: "2 Wustho", value: "WUSTHO_2" },
  { label: "3 Wustho", value: "WUSTHO_3" },
  { label: "1 Ulya", value: "ULYA_1" },
  { label: "2 Ulya", value: "ULYA_2" },
  { label: "3 Ulya", value: "ULYA_3" },
  { label: "Purna Alfiyah", value: "PURNA_PI" },
  { label: "Mutakhorijin", value: "MUTAKHOR_PI" }
];

export const pengajianPutras = [
  { label: "SEMUA", value: "ALL" },
  { label: "Al Awamil", value: "AWAM" },
  { label: "Al Ajurumiyyah", value: "AJURU" },
  { label: "Al Amrithi", value: "AMRI" },
  { label: "Al Mutammimah", value: "MUTTA" },
  { label: "Alfiyah Ula", value: "ULA" },
  { label: "Alfiyah Tsani", value: "TSANI" },
  { label: "Purna Alfiyah", value: "PURNA_PA" },
  { label: "Mutakhorijin", value: "MUTAKHOR_PA" }
];

export const pengajianMisykats = [
  { label: "SEMUA", value: "ALL" },
  { label: "Al Ajurumiyyah Misykat", value: "10_AJURU" },
  { label: "Al Amrithi Misykat", value: "11_AMR" },
  { label: "Alfiyah Misykat", value: "12_ALFI" },
  { label: "Mutakhorijin L", value: "MUTAKHOR_PA" },
  { label: "Mutakhorijin P", value: "MUTAKHOR_PI" }
];

/**
 * return hari as arrays from translation
 *
 *  @type {{name: any; value: any}[]}
 */
export const days: Array<any> = Object.keys(Constant.DAY).map((item: any) => {
  return { name: item, value: item };
});

export const months: Array<any> = Object.keys(Constant.MONTH).map((item: any) => {
  return { name: item, value: item };
});

export const bulanPembayarans: Array<any> = Object.keys(Constant.MONTH_PEMBAYARAN).map((item: any) => {
  return { name: item, value: item };
});

/**
 * Convert Pendidikan to Kode Pendidikan
 */
export const getKodePendidikan = (pendidikan: string) => {
  let kode = null;
  if (pendidikan == "PP. KHAS PUTRA") {
    kode = "PUTRA";
  } else if (pendidikan == "PP. KHAS PUTRI") {
    kode = "PUTRI";
  } else if (pendidikan == "MISYKAT AL-NURAIN PUTRA") {
    kode = "MISYKAT_PA";
  } else if (pendidikan == "MISYKAT AL-NURAIN PUTRI") {
    kode = "MISYKAT_PI";
  } else if (pendidikan == "MTs KHAS Kempek") {
    kode = "MTS";
  } else if (pendidikan == "SMP KHAS Kempek") {
    kode = "SMP";
  } else if (pendidikan == "MA KHAS Kempek") {
    kode = "MA";
  } else if (pendidikan == "SMK KHAS Kempek") {
    kode = "SMK";
  } else if (pendidikan == "STIES KHAS Kempek") {
    kode = "STIES";
  } else if (pendidikan == "STIKES KHAS Kempek") {
    kode = "STIKES";
  }
  return kode;
};

export const getJenisTransaksi = (kode: string) => {
  let nama = "";
  if (kode == "CASH") {
    nama = "Transaksi Cash";
  } else if (kode == "VA") {
    nama = "Transaksi Virtual Account";
  }
  return nama;
};

export const getPenerimaDana = (kode: string) => {
  let nama = "";
  if (kode == "YSN_SMP_MTS" || kode == "YSN_MA_SMK" || kode == "YSN_MA_SMK_KHAS" || kode == "YSN_KHAS") {
    nama = "Yayasan KHAS Kempek";
  } else if (kode == "SMP") {
    nama = "SMP KHAS Kempek";
  } else if (kode == "MTS") {
    nama = "MTs KHAS Kempek";
  } else if (kode == "MA") {
    nama = "MA KHAS Kempek";
  } else if (kode == "SMK") {
    nama = "SMK KHAS Kempek";
  } else if (kode == "STIES") {
    nama = "STIES KHAS Kempek";
  } else if (kode == "STIKES") {
    nama = "STIKES KHAS Kempek";
  } else if (kode == "GHAZHIER") {
    nama = "AL GHAZHIER";
  } else if (kode == "JADIED_PA") {
    nama = "AL JADIED PUTRA";
  } else if (kode == "JADIED_PA_2") {
    nama = "AL JADIED PUTRA 2";
  } else if (kode == "JADIED_PA_3") {
    nama = "AL JADIED PUTRA 3";
  } else if (kode == "MISYKAT_PA") {
    nama = "MISYKAT AL NURAIN PUTRA";
  } else if (kode == "MISYKAT_PI") {
    nama = "MISYKAT AL NURAIN PUTRI";
  } else if (kode == "JADIED_PI") {
    nama = "AL-JADIED PUTRI";
  } else if (kode == "AL_NASHIR") {
    nama = "AL-NASHIR AL-MANSHUR";
  } else if (kode == "AS_SYIFA") {
    nama = "AS-SYIFA";
  } else if (kode == "EL_SHOFA") {
    nama = "DAR EL SHOFA";
  } else if (kode == "MADINATUS") {
    nama = "MADINATUS SHOLAWAT";
  } else if (kode == "AZ_ZAHRA") {
    nama = "AZ ZAHRA";
  } else if (kode == "MADRASAH") {
    nama = "MADRASAH";
  } else if (kode == "YAYASAN") {
    nama = "YAYASAN";
  } else if (kode == "MASYAYIKH") {
    nama = "MASYAYIKH";
  } else if (kode == "BENDAHARA_PUSAT") {
    nama = "BENDAHARA PUSAT";
  } else if (kode == "BENDAHARA") {
    nama = "BENDAHARA";
  }
  return nama;
};

export const getPengajian = (param: string) => {
  let name = "-";
  if (param == "AWAM") {
    name = "Al Awamil";
  } else if (param == "AJURU") {
    name = "Al Ajurumiyyah";
  } else if (param == "AMRI") {
    name = "Al Amrithi";
  } else if (param == "MUTTA") {
    name = "Al Mutammimah";
  } else if (param == "ULA") {
    name = "Alfiyah Ula";
  } else if (param == "TSANI") {
    name = "Alfiyah Tsani";
  } else if (param == "WUSTHO_1") {
    name = "1 Wustho";
  } else if (param == "WUSTHO_2") {
    name = "2 Wustho";
  } else if (param == "WUSTHO_3") {
    name = "3 Wustho";
  } else if (param == "ULYA_1") {
    name = "1 Ulya";
  } else if (param == "ULYA_2") {
    name = "2 Ulya";
  } else if (param == "ULYA_3") {
    name = "3 Ulya";
  } else if (param == "PURNA_PA") {
    name = "Purna Alfiyah L";
  } else if (param == "PURNA_PI") {
    name = "Purna Alfiyah P";
  } else if (param == "MUTAKHOR_PA") {
    name = "Mutakhorijin P";
  } else if (param == "MUTAKHOR_PI") {
    name = "Mutakhorijin L";
  } else if (param == "10_AJURU") {
    name = "Al Ajurumiyyah Misykat";
  } else if (param == "11_AMR") {
    name = "Al Amrithi Misykat";
  } else if (param == "12_ALFI") {
    name = "Alfiyah Misykat";
  }

  return name.toUpperCase();
};

export const getPengajianTypeSelect = (role: string) => {
  let nama: string;
  if (role == "JADIED_PA" || role == "JADIED_PA_2" || role == "JADIED_PA_3" || role == "GHAZHIER") {
    nama = "PUTRA";
  } else if (role == "MISYKAT_PA" || role == "MISYKAT_PI") {
    nama = "MISYKAT";
  } else {
    nama = "PUTRI";
  }

  return nama;
};

export const isPerguruanTinggi = (role: string) => {
  return role == "STIKES" || role == "STIES";
};

export const isSLTP = (role: string) => {
  return role == "SMP" || role == "MTS";
};

export const isSLTA = (role: string) => {
  return role == "MA" || role == "SMK";
};

export const isPendidikanFormal = (role: string) => {
  return role == "STIKES" || role == "STIES" || role == "SMK" || role == "MA" || role == "SMP" || role == "MTS";
};

export const getJenisKelaminWilayah = (wilayah: string) => {
  let nama: string;
  if (wilayah == "JADIED_PA" || wilayah == "JADIED_PA_2" || wilayah == "JADIED_PA_3" || wilayah == "GHAZHIER" || wilayah == "MISYKAT_PA") {
    nama = "L";
  } else {
    nama = "P";
  }

  return nama;
};

export const getAsramaTypeSelect = (role: string) => {
  let nama: string;
  if (role == "JADIED_PA" || role == "JADIED_PA_2" || role == "JADIED_PA_3" || role == "GHAZHIER") {
    nama = "PUTRA";
  } else if (role == "MISYKAT_PA" || role == "MISYKAT_PI") {
    nama = "PUTRA";
  } else {
    nama = "PUTRI";
  }

  return nama;
};

export const getJenisKelamin = (kode: string) => {
  let nama = "";
  if (kode == "L") {
    nama = "LAKI-LAKI";
  } else if (kode == "P") {
    nama = "PEREMPUAN";
  }
  return nama;
};

/**
 * return date value by Date()
 * start at senin = 1
 */
export const getDayValueByDate = (date: Date) => {
  const day = date.getDay();

  if (day === 0) {
    return 7;
  }

  return day;
};

/**
 * return month value by Date()
 * start at juli = 1 and juni = 12
 */
export const getMonthValueByDate = (date: Date) => {
  let indo = moment(date).locale("ID");
  const name = indo.format("MMMM");
  let month = 0;

  Object.keys(Constant.MONTH_PEMBAYARAN).map((key: string, value: any) => {
    if (key == name) {
      month = value + 1;
    }
  });

  return month;
};

/**
 * return day that valid to v-calendar component weekdays
 * sabtu = 7, minggu = 1
 *
 * from backend senin = 1
 *
 * @param day
 */
export const dayToDisabledWeek = (day: number) => {
  let dayFmt = null;

  if (day === 1) {
    dayFmt = 2;
  } else if (day === 2) {
    dayFmt = 3;
  } else if (day === 3) {
    dayFmt = 4;
  } else if (day === 4) {
    dayFmt = 5;
  } else if (day === 5) {
    dayFmt = 6;
  } else if (day === 6) {
    dayFmt = 7;
  } else if (day === 7) {
    dayFmt = 1;
  }

  return dayFmt;
};

/**
 * Number to string
 * @param day
 */
export const dayToString = (day: number) => {
  let dayFmt = null;
  if (day === 1) {
    dayFmt = "Senin";
  } else if (day === 2) {
    dayFmt = "Selasa";
  } else if (day === 3) {
    dayFmt = "Rabu";
  } else if (day === 4) {
    dayFmt = "Kamis";
  } else if (day === 5) {
    dayFmt = "Jumat";
  } else if (day === 6) {
    dayFmt = "Sabtu";
  } else if (day === 7) {
    dayFmt = "Minggu";
  }

  return dayFmt;
};

export const monthToNumber = (month: string) => {
  let number = 0;
  if (month == "Januari") {
    number = 1;
  } else if (month == "Februari") {
    number = 2;
  } else if (month == "Maret") {
    number = 3;
  } else if (month == "April") {
    number = 4;
  } else if (month == "Mei") {
    number = 5;
  } else if (month == "Juni") {
    number = 6;
  } else if (month == "Juli") {
    number = 7;
  } else if (month == "Agustus") {
    number = 8;
  } else if (month == "September") {
    number = 9;
  } else if (month == "Oktober") {
    number = 10;
  } else if (month == "November") {
    number = 11;
  } else if (month == "Desember") {
    number = 12;
  }

  return number;
};

export const monthToString = (month: number) => {
  let bulan = "-";
  if (month == 1) {
    bulan = "Januari";
  } else if (month == 2) {
    bulan = "Februari";
  } else if (month == 3) {
    bulan = "Maret";
  } else if (month == 4) {
    bulan = "April";
  } else if (month == 5) {
    bulan = "Mei";
  } else if (month == 6) {
    bulan = "Juni";
  } else if (month == 7) {
    bulan = "Juli";
  } else if (month == 8) {
    bulan = "Agustus";
  } else if (month == 9) {
    bulan = "September";
  } else if (month == 10) {
    bulan = "Oktober";
  } else if (month == 11) {
    bulan = "November";
  } else if (month == 12) {
    bulan = "Desember";
  }
  return bulan;
};

/**
 * return all nama bulans
 *
 * @type {{name: any; value: any}[]}
 */
export const bulans = (tahunAjaran: string = ""): Array<any> => {
  const arr12 = new Array(12);
  const paramReturn = (date: Date) => {
    return { date, value: date.getMonth() + 1, name: moment(date).locale("ID").format(Constant.MONTH_NAME) };
  };

  if (tahunAjaran) {
    return arr12.fill(null).map((item: any, index: number) => {
      const [smGanjil, smGenap] = tahunAjaran.split("/").map((item: string) => parseInt(item));

      const i = index + 1;
      let date = null;

      if (i <= 6) {
        date = new Date(smGanjil, 6 + index, 1);
      } else {
        date = new Date(smGenap, i - 7, 1);
      }

      return paramReturn(date);
    });
  }

  return arr12.fill(null).map((item: any, index: number) => {
    return paramReturn(new Date(new Date().getFullYear(), index, 1));
  });
};

export const bulanNames: Array<string> = [
  "Juli", "Agustus", "September",
  "Oktober", "November", "Desember",
  "Januari", "Februari", "Maret",
  "April", "Mei", "Juni"
];

export const hariNames: Array<string> = [
  "Senin", "Selasa", "Rabu",
  "Kamis", "Jum'at", "Sabtu",
  "Minggu"
];

export const bulanNameShorts: Array<string> = [
  "Jul", "Agu", "Sep", "Okt", "Nov", "Des",
  "Jan", "Feb", "Mar", "Apr", "Mei", "Jun"
];

export var loopDates = function(startDate, endDate) {
  var dates = [],
    currentDate = startDate,
    addDays = function(days) {
      // @ts-ignore
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };

  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }

  return dates;
};

/**
 * fill date range through two dates
 *
 * @param minDate
 * @param maxDate
 */
export const fillDateRange = (minDate: Date, maxDate: Date): Array<Date> => {
  return new Array((maxDate.getDate() - minDate.getDate()) + 1)
    .fill(null).map((item: any, idx: number) => {
      return new Date(minDate.getFullYear(), minDate.getMonth(), idx + 1);
    });
};

export const convertToCDNUrl = (url: string) => {
  return url.replace(".sgp1.digitaloceanspaces.com", ".sgp1.cdn.digitaloceanspaces.com");
};
